import {
  ArrowBendDoubleUpLeft,
  ArrowBendDoubleUpRight,
  Selection,
} from "@phosphor-icons/react";
import type { LoadedRefinePage } from "../../hooks/useRefinePage";
import { AddAsAssetModal } from "../AddAsAssetModal";
import { Button } from "../Button";
import { ReferenceImagePill } from "../ReferenceImagePill";
import { RefinePromptBar } from "./RefinePromptBar";

function ReferenceImageRow({ page }: { page: LoadedRefinePage }) {
  const { referenceImages, setReferenceImages } = page;
  if (referenceImages.length === 0) return null;

  return (
    <div className="flex shrink-0 items-center gap-3">
      {referenceImages.map((dataUrl, index) => (
        <ReferenceImagePill
          key={dataUrl}
          imageIndex={index}
          imageDataUrl={dataUrl}
          onRemove={() =>
            setReferenceImages(referenceImages.filter((_, i) => i !== index))
          }
          disabled={page.isRegenerating || page.isLoading}
        />
      ))}
    </div>
  );
}

export function RefineBottomBar({ page }: { page: LoadedRefinePage }) {
  // Right gutter keeps the open prompt (and its in-field submit) clear of the
  // Sentry feedback trigger fixed to the viewport corner.
  return (
    <div className="flex items-center gap-3 pr-28">
      <Button
        variant="toolbar"
        onClick={page.handleUndo}
        disabled={!page.image.parent_image_id}
        className="shrink-0"
      >
        Undo
        <ArrowBendDoubleUpLeft size={16} aria-hidden />
      </Button>
      <Button
        variant="toolbar"
        onClick={page.handleRedo}
        disabled={!page.image.latest_child_image_id}
        className="shrink-0"
      >
        Redo
        <ArrowBendDoubleUpRight size={16} aria-hidden />
      </Button>
      <Button
        variant="toolbar"
        onClick={page.selection.toggle}
        aria-pressed={page.selection.isActive}
        disabled={page.isRegenerating}
        className="shrink-0"
      >
        Select
        <Selection size={16} aria-hidden />
      </Button>
      <RefinePromptBar page={page} />
      <ReferenceImageRow page={page} />
      <AddAsAssetModal prompt={page.assetPrompt} />
    </div>
  );
}
